import { render, staticRenderFns } from "./CreateRoleForm.vue?vue&type=template&id=107056c9&scoped=true&"
import script from "./CreateRoleForm.vue?vue&type=script&lang=js&"
export * from "./CreateRoleForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateRoleForm.vue?vue&type=style&index=0&id=107056c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107056c9",
  null
  
)

export default component.exports